import { useQuery } from "react-query"
import PerkService from "~services/PerkService"

const usePerks = (options?) => {
  return useQuery("perks", () => PerkService.getPerks(options), {
    enabled: false,
  })
}

export default usePerks
